import axios from "axios";
import type { AxiosInstance, CreateAxiosDefaults, AxiosRequestConfig } from "axios";
import router from "@/router";

// Documentation: https://axios-http.com/docs/req_config
const config: CreateAxiosDefaults = {
  baseURL: import.meta.env.VITE_API_BASE_URL
};

const axiosInstance = axios.create(config);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // 403 - Forbidden
    if (
      error.config.method === "get" &&
      error.response?.status === 403 &&
      error.response?.data.errors[0].code !== 4003
    ) {
      router.push({ name: "PageRestricted" });
      // 404 - Not Found
    } else if (error.config.method === "get" && error.response?.status === 404) {
      router.push({ name: "NotFound" });
      // 500 - Server Error
    } else if (error.config.method === "get" && error.response?.status === 500) {
      router.push({ name: "ServerError" });
    }

    return Promise.reject(error);
  }
);

// Use this Axios instance for public API endpoints that don't require authentication
const publicApi = (axios: AxiosInstance) => {
  return {
    get: (url: string, config?: AxiosRequestConfig) => axios.get(url, config),
    patch: (url: string, data?: any, config?: AxiosRequestConfig) => axios.patch(url, data, config),
    post: (url: string, data?: any, config?: AxiosRequestConfig) => axios.post(url, data, config)
  };
};

export default publicApi(axiosInstance);
